export default __webpack_public_path__ + "static/media/7.5fc9b0d5.png";